import styled from 'styled-components';

export const ContainerNav = styled.div``;

export const Item = styled.div`
  margin: 1rem 0;
  position: relative;
  max-width: 100%;
  height: 70px;
  padding: 0.25rem;
  background: ${({ theme }) => theme.colors.tertiary};
  border-radius: 0.5rem;

  h6 {
    color: ${({ theme }) => theme.colors.textPrimary};
    background: transparent;
    margin-bottom: 0.5rem;
    margin-left: 0.25rem;
    flex: 1;
    font-size: 0.9rem;
  }
`;

export const Thumb = styled.div`
  width: 50px;
  height: 50px;
  background: ${({ theme }) => theme.colors.primary};
  position: relative;
  border-radius: 0.5rem;
  overflow: hidden;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

export const NoThumb = styled.div`
  width: 50px;
  height: 50px;
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 1.5rem;
    color: ${({ theme }) => theme.colors.textTertiary};
  }
`;

export const ContainerButtons = styled.div`
  position: absolute;
  right: 5px;
  bottom: 5px;
  display: flex;
  align-items: center;

  button {
    background: ${({ theme }) => theme.colors.bg};
    color: ${({ theme }) => theme.colors.textTertiary};
    font-size: 1.1rem;
    border-radius: 0.5rem;
    padding: 0.25rem;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s linear;

    & + button {
      margin-left: 0.5rem;
    }

    &:hover {
      color: ${({ theme }) => theme.colors.textPrimary};
    }
  }
`;
